module.exports = __webpack_public_path__ + "static/media/colheitadeira.b469cada.svg";